export const VIP = 1000;


// WEBPACK FOOTER //
// ./src/constants/PurchaseVip.js